import {
  forwardRef,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from '@cardboard-ui/react';
import { SearchIcon } from 'components/icons';
import React from 'react';
import { t } from '@lingui/macro';

const SearchField = forwardRef<InputProps, 'input'>((props, ref) => (
  <InputGroup size={props.size || 'sm'} variant="filled">
    <InputRightElement color="gray.400">
      <SearchIcon />
    </InputRightElement>
    <Input
      ref={ref}
      rounded="md"
      placeholder={props.placeholder || t`Search`}
      _placeholder={{ color: 'gray.400' }}
      {...props}
    />
  </InputGroup>
));

export default SearchField;
